export enum FightResult {
    IN_PROCESS = "IN_PROCESS",
    WIN = "WIN",
    FAIL = "FAIL"
}